/* Luxe Crown Co. — theme behaviour. Native Shopify cart (AJAX Cart API), drawers, variant picker. */
(function () {
  "use strict";

  /* ---------------- drawers ---------------- */
  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var focusable = drawer.querySelector("[data-drawer-close]");
    if (focusable) focusable.focus();
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  document.addEventListener("click", function (event) {
    var opener = event.target.closest("[data-drawer-open]");
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute("data-drawer-open"));
      return;
    }
    if (event.target.closest("[data-drawer-close]") || event.target.hasAttribute("data-drawer-overlay")) {
      closeDrawer(event.target.closest(".drawer"));
    }
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      document.querySelectorAll(".drawer.is-open").forEach(closeDrawer);
    }
  });

  /* ---------------- cart ---------------- */
  function refreshCart(open) {
    return fetch(window.Shopify.routes.root + "?sections=cart-drawer,cart-icon-bubble", {
      headers: { "Content-Type": "application/json" }
    })
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        var drawer = document.getElementById("CartDrawer");
        if (sections["cart-drawer"] && drawer) {
          var parsed = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
          var next = parsed.getElementById("CartDrawer");
          if (next) drawer.innerHTML = next.innerHTML;
        }
        var bubble = document.getElementById("CartIconBubble");
        if (sections["cart-icon-bubble"] && bubble) {
          var parsedBubble = new DOMParser().parseFromString(sections["cart-icon-bubble"], "text/html");
          var nextBubble = parsedBubble.getElementById("CartIconBubble");
          if (nextBubble) bubble.innerHTML = nextBubble.innerHTML;
        }
        if (open) openDrawer("CartDrawer");
      })
      .catch(function (error) { console.error("Cart refresh failed", error); });
  }

  function setBusy(form, busy) {
    var button = form && form.querySelector('[type="submit"]');
    if (!button) return;
    if (busy) {
      button.dataset.label = button.textContent;
      button.setAttribute("disabled", "disabled");
      button.textContent = window.LuxeStrings ? window.LuxeStrings.adding : "Adding…";
    } else {
      button.removeAttribute("disabled");
      if (button.dataset.label) button.textContent = button.dataset.label;
    }
  }

  document.addEventListener("submit", function (event) {
    var form = event.target.closest('form[data-cart-add]');
    if (!form) return;
    event.preventDefault();
    setBusy(form, true);
    var body = new FormData(form);
    body.append("sections", "cart-drawer,cart-icon-bubble");
    fetch(window.Shopify.routes.root + "cart/add.js", { method: "POST", body: body })
      .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
      .then(function (result) {
        setBusy(form, false);
        if (!result.ok) {
          var error = form.querySelector("[data-cart-error]");
          if (error) error.textContent = result.data.description || result.data.message || "";
          return;
        }
        return refreshCart(true);
      })
      .catch(function (error) { setBusy(form, false); console.error(error); });
  });

  function changeLine(key, quantity) {
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { return refreshCart(false); });
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-line-change]");
    if (!button) return;
    event.preventDefault();
    changeLine(button.getAttribute("data-line-key"), Number(button.getAttribute("data-line-quantity")));
  });

  document.addEventListener("change", function (event) {
    var input = event.target.closest("[data-line-quantity-input]");
    if (!input) return;
    changeLine(input.getAttribute("data-line-key"), Number(input.value));
  });

  /* quantity stepper (product page) */
  document.addEventListener("click", function (event) {
    var step = event.target.closest("[data-quantity-step]");
    if (!step) return;
    var input = step.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var next = Number(input.value) + Number(step.getAttribute("data-quantity-step"));
    input.value = String(Math.max(1, next));
  });

  /* ---------------- variant picker ---------------- */
  function initVariantPicker(root) {
    var dataEl = root.querySelector("[data-variant-json]");
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector("[data-variant-id]");
    var priceTarget = root.querySelector("[data-variant-price]");
    var submit = root.querySelector('[type="submit"]');
    var badge = root.querySelector("[data-variant-availability]");

    function currentOptions() {
      return Array.prototype.map.call(root.querySelectorAll("[data-option-index]"), function (group) {
        var checked = group.querySelector("input:checked");
        return checked ? checked.value : null;
      });
    }

    function update() {
      var selected = currentOptions();
      var match = variants.find(function (variant) {
        return selected.every(function (value, index) { return value === null || variant.options[index] === value; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceTarget && match.price_html) priceTarget.innerHTML = match.price_html;
      if (badge) badge.textContent = match.available ? badge.getAttribute("data-in-stock") : badge.getAttribute("data-sold-out");
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? submit.getAttribute("data-add-label") : submit.getAttribute("data-sold-out-label");
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", match.id);
        history.replaceState({}, "", url.toString());
      }
      var featured = root.querySelector('[data-variant-media="' + match.id + '"]');
      if (featured) featured.click();
    }

    root.addEventListener("change", function (event) {
      if (event.target.matches("[data-option-value]")) update();
    });
    update();
  }
  document.querySelectorAll("[data-variant-picker]").forEach(initVariantPicker);

  /* ---------------- product gallery ---------------- */
  document.addEventListener("click", function (event) {
    var thumb = event.target.closest("[data-gallery-thumb]");
    if (!thumb) return;
    var gallery = thumb.closest("[data-gallery]");
    var main = gallery.querySelector("[data-gallery-main]");
    if (main) {
      main.src = thumb.getAttribute("data-image");
      main.srcset = thumb.getAttribute("data-srcset") || "";
      main.alt = thumb.getAttribute("data-alt") || main.alt;
    }
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (item) {
      item.setAttribute("aria-current", item === thumb ? "true" : "false");
    });
  });

  /* ---------------- collection sort ---------------- */
  document.addEventListener("change", function (event) {
    var select = event.target.closest("[data-sort-select]");
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set("sort_by", select.value);
    url.searchParams.delete("page");
    window.location.href = url.toString();
  });
})();
